<template>
  <div v-if="ShowPopup" class="popup__overlay" @click="close">
    <div class="popup__content">
      <button class="popup__close-button" @click="close">X</button>
      <slot></slot>

      <div class="popup__footer">
        <BaseCheckbox v-model="dontShowAgain">
          Não mostrar novamente
        </BaseCheckbox>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCheckbox from '@/components/form/BaseCheckbox'

export default {
  components: {
    BaseCheckbox,
  },
  data() {
    return {
      ShowPopup: true,
      dontShowAgain: false,
      cookieName: '',
    }
  },
  mounted() {
    this.cookieName = this.genarateCookieName()
    if (localStorage.getItem(this.cookieName)) {
      this.ShowPopup = false;
    }
  },
  methods: {
    generateHash(content) {
      let hash = 0
      for (let i = 0; i < content.length; i++) {
        const char = content.charCodeAt(i)
        hash = (hash << 5) - hash + char
        hash |= 0
      }
      return hash
    },
    genarateCookieName() {
      const slotContent = this.$slots.default;
      if (slotContent && slotContent.length > 0) {
        for (let vnode of slotContent) {
          if (vnode.componentOptions) {
            return vnode.componentOptions.tag.toLowerCase() + '-popup'
          } else if (vnode.text) {
            return this.generateHash(vnode.text) + '-popup'
          }
       }
      }
      return 'no-popup'
    },
    close() {
      this.ShowPopup = false;
      if (this.dontShowAgain) {
        localStorage.setItem(this.cookieName, 1);
      }
    },
  }
}
</script>

<style scoped lang="scss">
.popup {
    &__overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 1000;
    }
    &__content {
        background: white;
        border-radius: 8px;
        padding: 20px;
        position: relative;
    }
    &__close-button {
        position: absolute;
        top: 10px;
        right: 10px;
        background: #ff6f6f;
        border: none;
        color: white;
        border-radius: 50%;
        width: 30px;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    &__footer {
      margin-top: 20px;
      display: flex;
      align-items: center;

      input[type="checkbox"] {
        margin-right: 10px;
        width: auto;
      }
    }
}
</style>